module.exports = __webpack_public_path__ + "static/media/15.f5a414ac.jpg";